import { useState, useCallback } from 'react';
import { TX_STATES, createInitialTxStates, isTransactionInProgress } from '../constants/transactionStates';

export const useTransactionStates = () => {
    const [txStates, setTxStates] = useState(createInitialTxStates());

    const updateTxState = useCallback((type, newState) => {
        setTxStates(prev => ({
            ...prev,
            [type]: newState
        }));
    }, []);

    const resetTxState = useCallback((type) => {
        setTimeout(() => {
            setTxStates(prev => ({
                ...prev,
                [type]: TX_STATES.IDLE
            }));
        }, 2000);
    }, []);

    const getButtonState = useCallback((type) => {
        const isAnyTxInProgress = isTransactionInProgress(txStates);
        const currentTxState = txStates[type];

        return {
            state: currentTxState,
            isDisabled: isAnyTxInProgress || currentTxState === TX_STATES.CONFIRMED,
            text: getButtonText(type, currentTxState)
        };
    }, [txStates]);

    return {
        txStates,
        updateTxState,
        resetTxState,
        getButtonState
    };
};

const getButtonText = (type, state) => {
    switch (state) {
        case TX_STATES.ESTIMATING:
            return 'Estimating Gas...';
        case TX_STATES.PENDING:
            return type === 'claim' ? 'Claiming...' : 'Minting...';
        case TX_STATES.CONFIRMED:
            return type === 'claim' ? 'Claimed!' : 'Minted!';
        case TX_STATES.FAILED:
            return 'Failed';
        default:
            return type === 'claim' ? 'Claim' : 'Mint';
    }
};